import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const AccordionCriteriaTitle = styled(Typography)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
  fontWeight: '600',
  margin: '12px 0',
  cursor: 'pointer',
  '& span': { color: theme.palette.secondary.main },
}));
